<template>
    <ac-modal :title="'Outstanding Items'" ref="modal">
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning" v-if="companyBankingInfoNeeded">
                        <div class="row">
                            <div class="col-lg-1">
                                <span class="fa fa-2x fa-exclamation-circle"></span>
                            </div>
                            <div class="col-lg-11">
                                <span v-if="companyACHInfoNeeded">
                                    Your account is missing banking information.<br>
                                </span>                                
                                <span v-if="companyCreditCardInfoNeeded">
                                    Your account is missing credit card information.<br>
                                </span>
                                Please click
                                <router-link :to="{name:'paymentMethod',params:{companyId}}" @click.native="closeModal">here</router-link>
                                to update your profile with current banking information as soon as possible.
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-warning" v-if="hasOutstandingPayment">
                        <div class="row">
                            <div class="col-lg-1">
                                <span class="fa fa-2x fa-exclamation-circle"></span>
                            </div>
                            <div class="col-lg-11" >
                                You have an outstanding payment on your account.<br>
                                Please click
                                <router-link :to="{name:'outstandingPayments',params:{companyId}}" @click.native="closeModal">here</router-link>
                                to make your payment.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "OutstandingItemsModal",
        props: {
            companyId: {type: [Number], required: true},
            companyBankingInfoNeeded: {type: [Boolean], required: true},
            hasOutstandingPayment: {type: [Boolean], required: true}
        },
        computed: {
            ...mapGetters({companyACHInfoNeeded: 'globalSettings/companyACHInfoNeeded'}),
            ...mapGetters({companyCreditCardInfoNeeded: 'globalSettings/companyCreditCardInfoNeeded'})
        },
        methods: {
            showModal() {
                this.$refs.modal.open();
            },
            closeModal() {
                this.$refs.modal.close();
            }
        }
    }
</script>

<style scoped>

</style>